// extracted by mini-css-extract-plugin
module.exports = {"basicItemContainer":"BasicItem_basicItemContainer__4OYM_","basicItemCard":"BasicItem_basicItemCard__rsnGL","basicIngredientName":"BasicItem_basicIngredientName__99Kqf"};